var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},[_c('h4',{staticClass:"text-uppercase"},[_vm._v("Tuesday, December 21")]),_c('h2',{staticClass:"text-uppercase"},[_vm._v("Good Afternoon, User")]),_c('projectList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }